let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gxipV")).then(() => parcelRequire('bG4aH'));